import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TManpowerDB } from './manpower.reducer';

export const MANPOWER_APP_STATE = 'MANPOWER_APP_STATE';
export const manpowerDB = createFeatureSelector<TManpowerDB>(MANPOWER_APP_STATE);

export const getTableHeaderConfig = createSelector(manpowerDB, (db) => {
  return db.tableHeaderConfig;
});

export const getManpowerList = createSelector(manpowerDB, (db) => {
  return db.manpowerList;
});

export const getManpowerActivityLog = createSelector(manpowerDB, (db) => {
  return db.activityLog;
});
